import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import useEtiquetas from '../../../hooks/useEtiquetas';
import transformWord from '../../../utils/transformWord';
import riesgoEudrCalculator from '../../../nuup/utils/riesgoEudrCalculator.js';
import getRiesgoEudrLabel from '../../../nuup/utils/getRiesgoEudrLabel.js';
import ParcelasDonutCard from './parcelas-donut-card';

export const RISK_LEVELS = [
  { key: 'ALTO', label: 'Riesgo alto', color: '#B22E32' },
  { key: 'MEDIO', label: 'Riesgo medio', color: '#FFB04A' },
  { key: 'BAJO', label: 'Riesgo bajo', color: '#6F9F3A' },
  { key: 'SIN_ASIGNAR', label: 'Sin asignar', color: '#949494' },
];

// Risk key (ALTO, MEDIO, BAJO, SIN_ASIGNAR) of a parcelas_all row
export const getParcelaRiskKey = item =>
  getRiesgoEudrLabel(
    riesgoEudrCalculator(
      item.poligono,
      item.id_riesgo_eudr_user,
      item.alertas_error_poligono_count,
      item.id_riesgo_eudr_whisp,
      item.areas_naturales_count
    )
  );

const riskFilterPath = riskKey => ({
  pathname: '/admin/parcelas/list',
  search: `?riskFilter=${riskKey}`,
});

// parcelas: rows from parcelas_all (see hooks/useParcelasAll)
const ParcelasResumenEudrRiesgo = ({ parcelas, blocking }) => {
  const history = useHistory();
  const { etiquetas } = useEtiquetas();

  const dataRiesgo = useMemo(() => {
    const riskKeys = parcelas.map(getParcelaRiskKey);
    return RISK_LEVELS.map(risk => ({ ...risk, value: riskKeys.filter(riskKey => riskKey === risk.key).length }));
  }, [parcelas]);

  return (
    <ParcelasDonutCard
      title="Riesgo EUDR"
      total={parcelas.length}
      totalLabel={transformWord(etiquetas?.parcela, ['plural', 'capitalize'])}
      blocking={blocking}
      items={dataRiesgo.map(risk => ({ ...risk, to: riskFilterPath(risk.key) }))}
      onSegmentClick={riskKey => history.push(riskFilterPath(riskKey))}
    />
  );
};

export default ParcelasResumenEudrRiesgo;
